// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import $ from "jquery";
window.$ = window.jQuery = $;
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "bootstrap";
import "../stylesheets/application";
require("admin-lte");
require("image_uploadify/imageuploadify.min");
import "@fortawesome/fontawesome-free/js/all";
import "../shared/cloudinary";

// Import toastr
import toastr from 'toastr'
window.toastr = toastr

// Configure toastr
toastr.options = {
  closeButton: true,
  progressBar: true,
  positionClass: "toast-top-right",
  timeOut: 5000
}

Rails.start();
Turbolinks.start();
ActiveStorage.start();

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
  event.preventDefault();
  $(this).ekkoLightbox({
    alwaysShowClose: true,
    showArrows: true,
    wrapping: true,
    loadingMessage: 'Loading...',
    leftArrow: '‹',
    rightArrow: '›',
    type: 'image',
    showCaption: true,
    onShown: function () {
      // The title is already set via data-title attribute
    },
    onNavigate: function (direction, itemIndex) {
      // Navigation is handled automatically by ekko-lightbox
    },
  });
});



// Import flash message handling
import { handleFlashMessages, showMessage } from './flash_messages';

// Get user's timezone and save it in a cookie
function setTimezoneCookie() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  document.cookie = `timezone=${timezone};path=/`;
}

// Import property notes handling
import './property_notes';

// Import property images handling
import './property_images';

// Import property note images handling
 import './property_note_images';

document.addEventListener("turbolinks:load", () => {
  // Set timezone cookie on page load
  setTimezoneCookie();

  // Initialize toastr options
  toastr.options = {
    closeButton: true,
    progressBar: true,
    positionClass: "toast-top-right",
    timeOut: 5000,
    preventDuplicates: true
  };

  // Handle URL parameters for messages
  const urlParams = new URLSearchParams(window.location.search);
  const message = urlParams.get('message');
  const messageType = urlParams.get('message_type');
  
  if (message) {
    showMessage(message, messageType);
    // Remove message from URL without reloading the page
    urlParams.delete('message');
    urlParams.delete('message_type');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }

  // Handle flash messages
  handleFlashMessages();

  $(document).ready(function () {
    function toggleSearchForm() {
      console.log("Toggling search form");
      if ($(window).width() > 768) {
        $("#search-form-modal").removeClass("d-none"); // Show on desktop
        $(".filter-button").addClass("active"); // Add active class on desktop
      } else {
        $("#search-form-modal").addClass("d-none"); // Hide on mobile
        $(".filter-button").removeClass("active"); // Remove active class on mobile
      }
    }

    // Initial check when the page loads
    toggleSearchForm();

    // Only handle window resize, remove scroll handling
    $(window).resize(function() {
      if ($(window).width() > 768) {
        toggleSearchForm();
      }
    });

    // Toggle search form when clicking the filter button
    $(".filter-button").click(function () {
      $("#search-form-modal").toggleClass("d-none");
      $(this).toggleClass("active", !$("#search-form-modal").hasClass("d-none"));
    });

    // Handler for changes in Priority checkboxes
    $(
      '#priorityDropdown + .dropdown-menu .dropdown-checkboxes input[type="checkbox"]'
    ).change(function () {
      var selectedPriorityOptions = [];
      $(
        '#priorityDropdown + .dropdown-menu .dropdown-checkboxes input[type="checkbox"]:checked'
      ).each(function () {
        selectedPriorityOptions.push($(this).val());
      });
      var priorityButtonText =
        selectedPriorityOptions.length > 0
          ? selectedPriorityOptions.join(", ")
          : "Select Priority";
      $("#priorityDropdown").text(priorityButtonText);
    });

    // Handler for changes in Source checkboxes
    $(
      '#sourceDropdown + .dropdown-menu .dropdown-checkboxes input[type="checkbox"]'
    ).change(function () {
      var selectedSourceOptions = [];
      $(
        '#sourceDropdown + .dropdown-menu .dropdown-checkboxes input[type="checkbox"]:checked'
      ).each(function () {
        selectedSourceOptions.push($(this).val());
      });
      var sourceButtonText =
        selectedSourceOptions.length > 0
          ? selectedSourceOptions.join(", ")
          : "Select Source";
      $("#sourceDropdown").text(sourceButtonText);
    });

    $(".overall_search").on("change", function (e) {
      $("#overall_search").submit();
    });
    $(".imageuploadify").imageuploadify();

    $("#propertyForm").on("submit", function () {
      var $submitButton = $(this).find('[type="submit"]');
      if ($submitButton.length) {
        $submitButton.attr("disabled", "disabled").val("Submitting...");
      }
    });

    $("#addPropertyImages").on("submit", function () {
      var $submitButton = $(this).find('[type="submit"]');
      if ($submitButton.length) {
        $submitButton.attr("disabled", "disabled").val("Uploading...");
      }
    });

    function downloadImage(imageUrl) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          const filename = imageUrl.split("/").pop();
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => alert("Download failed"));
    }

    // Handle image clicks
    document.querySelectorAll(".downloadable").forEach(function (image) {
      image.addEventListener("click", function () {
        downloadImage(image.src);
      });
    });

    // Handle download button clicks
    document.querySelectorAll(".downloadable-btn").forEach(function (button) {
      button.addEventListener("click", function () {
        const imageUrl = button.getAttribute("data-image-url");
        downloadImage(imageUrl);
      });
    });

    // Make entire mobile property card clickable
  document.querySelectorAll('.property-card[data-url]').forEach(function(card) {
    card.addEventListener('click', function(e) {
      // Allow clicks on links and buttons inside the card to work normally
      if (e.target.closest('a, button')) return;
      window.location.href = card.dataset.url;
    });
  });

  // Handle property note image deletion
    $(document).on('click', '.delete-property-note-image', function(e) {
      e.preventDefault();
      if (!confirm('Are you sure you want to delete this image?')) return;

      const deleteUrl = $(this).attr('href');
      const imageContainer = $(this).closest('.image-hover-container');
      const token = document.querySelector('meta[name="csrf-token"]').content;

      $.ajax({
        url: deleteUrl,
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': token
        },
        success: function(response) {
          imageContainer.fadeOut(300, function() {
            $(this).remove();
            // Update image count in tab
            const galleryTab = document.querySelector('#gallery-tab');
            const badge = galleryTab.querySelector('.badge');
            if (badge) {
              const count = parseInt(badge.textContent) - 1;
              if (count > 0) {
                badge.textContent = count;
              } else {
                badge.remove();
                // If no images left, show the 'No images' message
                const gallery = document.querySelector('.property-note-preview');
                if (gallery && !gallery.querySelector('.image-hover-container')) {
                  gallery.innerHTML = '<span class="text-muted">No images uploaded yet</span>';
                }
              }
            }
          });
        },
        error: function() {
          alert('Failed to delete image. Please try again.');
        }
      });
    });
  });
});
